import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

const RemoveMeetingReportConfirmationModal = (
  props: Omit<ConfirmationModalProps, "children">
) => (
  <ConfirmationModal
    {...props}
    confirmProps={{ type: "negative", label: "Remove report" }}
    title="Remove Report?"
    size="md"
  >
    <Typography variant="bodyPrimaryReg" color="shades.neutral.600">
      Removing this report means it will no longer be shown in your list of
      Reports. This will not affect access for anyone else.
    </Typography>
    <Alert severity="info">
      <Typography variant="bodySecondaryReg" color="shades.neutral.600">
        Only report Owners can permanently delete reports
      </Typography>
    </Alert>
  </ConfirmationModal>
);

export default RemoveMeetingReportConfirmationModal;
